import './Slide.css';
function Slide({children, name,className}) {
    return <div className={"slide " + (className ? className : "")} data-name={name}>{children}</div>
}

export default Slide;